import { z } from 'zod'
import { toNumberOrUndefined } from '../../../utils'

export const transitDetailSchema = z
  .object({
    id: z.number().optional(),
    carrierId: z.preprocess(toNumberOrUndefined, z.number().optional()),
    crossBorder: z.boolean().optional(),
    modeOfTransit: z
      .number({ message: 'Mode of transit is required' })
      .min(-1, { message: 'Mode of transit is required' }),
    transitIdentifier: z.string().optional(),
    carrierOption: z.string().optional(),
    fulfilmentRequired: z.boolean().optional(),
    scheduledDate: z.date().nullable().optional(),
  })
  .refine(
    (data) => {
      if (data.carrierOption === 'preBookedTransit' && !data.scheduledDate) {
        return false
      }
      return true
    },
    {
      message: 'Scheduled Date is required when Pre-Booked Transit is selected',
      path: ['scheduledDate'],
    }
  )
